import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_MANUAL_CASE_DETAIL_BY_ID = "GET_MANUAL_CASE_DETAIL_BY_ID";

export const service = async (eaCaseId) => {
  const options: object = {
    url: "/Api/EaCaseApiController/GetCaseDetail/" + eaCaseId + '/false',
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_MANUAL_CASE_DETAIL_BY_ID, service, mock);
